import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { TIME_AND_EXPENSE_ENTRY_TYPE } from '~/modules/common/enums/TimeAndExpenseEntryType';
import { useBillingStatusDropdown } from './hooks';

const BillingStatusDropdown = ({
  value,
  onChange,
  label,
  sourceProject = null,
  sourceTask = null,
  destinationProject = null,
  destinationTask = null
}) => {
  const {
    billingStatusOptions,
    handleChange,
    handleInputChange,
    getOptionLabel,
    getOptionSelected,
    getOptionDisabled,
    isDisabled,
    shouldShowNonBillableLabel,
    shouldShowBillableLabel,
    loading,
    formatMessage,
    renderOption
  } = useBillingStatusDropdown({
    value,
    onChange,
    sourceProject,
    sourceTask,
    destinationProject,
    destinationTask
  });

  useEffect(() => {
    if (shouldShowBillableLabel || shouldShowNonBillableLabel) {
      onChange({
        id: shouldShowBillableLabel
          ? TIME_AND_EXPENSE_ENTRY_TYPE.BILLABLE
          : TIME_AND_EXPENSE_ENTRY_TYPE.NON_BILLABLE,
        displayText: formatMessage({
          id: shouldShowBillableLabel
            ? 'moveTimeDialog.billable'
            : 'moveTimeDialog.nonBillable'
        })
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onChange, shouldShowNonBillableLabel, shouldShowBillableLabel]);

  const renderInput = useCallback(
    params => <TextField {...params} label={label} variant="filled" />,
    [label]
  );

  if (shouldShowBillableLabel || shouldShowNonBillableLabel)
    return (
      <Typography variant="body1">
        {formatMessage({
          id: shouldShowBillableLabel
            ? 'moveTimeDialog.billable'
            : 'moveTimeDialog.nonBillable'
        })}
      </Typography>
    );

  return (
    <Autocomplete
      fullWidth
      value={value}
      onChange={handleChange}
      onInputChange={handleInputChange}
      options={billingStatusOptions}
      getOptionLabel={getOptionLabel}
      getOptionSelected={getOptionSelected}
      getOptionDisabled={getOptionDisabled}
      loading={loading}
      disabled={isDisabled}
      renderInput={renderInput}
      renderOption={renderOption}
    />
  );
};

BillingStatusDropdown.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node,
  sourceProject: PropTypes.object,
  sourceTask: PropTypes.object,
  destinationProject: PropTypes.object,
  destinationTask: PropTypes.object
};

export default BillingStatusDropdown;
